export default[
    {
        name: 'CbQAll',
        path: 'CbQAll',
        component: () => import('@/pages/BigData/CopyrightModule/BanquanCopywrit/CbQAll'),
        meta: { title: '全部', requiresAuth: true },
        props(route) {
            return { id: route.query.id }
        },
    },
    {
        name: 'CbQToBeWritten',
        path: 'CbQToBeWritten',
        component: () => import('@/pages/BigData/CopyrightModule/BanquanCopywrit/CbQToBeWritten'),
        meta: { title: '待撰写', requiresAuth: true },
        props(route) {
            return { id: route.query.id }
        },
    },
    {
        name: 'CbQWriting',
        path: 'CbQWriting',
        component: () => import('@/pages/BigData/CopyrightModule/BanquanCopywrit/CbQWriting'),
        meta: { title: '撰写中', requiresAuth: true },
        props(route) {
            return { id: route.query.id }
        },
    },
    {
        name: 'CbQConfirming',
        path: 'CbQConfirming',
        component: () => import('@/pages/BigData/CopyrightModule/BanquanCopywrit/CbQConfirming'),
        meta: { title: '确认中', requiresAuth: true },
        props(route) {
            return { id: route.query.id }
        },
    },
    {
        name: 'CbQConfirmed',
        path: 'CbQConfirmed',
        component: () => import('@/pages/BigData/CopyrightModule/BanquanCopywrit/CbQConfirmed'),
        meta: { title: '已确认', requiresAuth: true },
        props(route) {
            return { id: route.query.id }
        },
    },
    {
        name: 'BanquanCopywritDetials',
        path: 'BanquanCopywritDetials',
        redirect:{name:'BQRawMaterials'},
        component: () => import('@/pages/BigData/CopyrightModule/BanquanCopywritDetials'),
        meta: { title: '详情', requiresAuth: true },
        props(route) {
            return { id: route.query.id }
        },
        children:[
            {
                name: 'BQRawMaterials',
                path: 'BQRawMaterials',
                component: () => import('@/pages/BigData/CopyrightModule/BanquanCopywritDetials/BQRawMaterials'),
                meta: { title: '申报材料', requiresAuth: true },
                props(route) {
                    return { id: route.query.id }
                },  
            },
            {
                name: 'BQConfirmMaterial',
                path: 'BQConfirmMaterial',
                component: () => import('@/pages/BigData/CopyrightModule/BanquanCopywritDetials/BQConfirmMaterial'),
                meta: { title: '确认材料', requiresAuth: true },
                props(route) {
                    return { id: route.query.id }
                },  
            },
         
        ]
    },
]